import React from 'react';
import PropTypes from 'prop-types';
import usePrivate from '@afosto/auth-react/usePrivate';
import { Route, Switch } from 'react-router-dom';
import BatchesContext from './BatchesContext';
import BatchesOverview from './BatchesOverview';
import CreateBatch from './CreateBatch';
import ViewBatch from './ViewBatch';

const BatchesPage = ({ actionsCode, excludeActions }) => {
  usePrivate();

  return (
    <BatchesContext.Provider value={{ actionsCode, excludeActions }}>
      <Switch>
        <Route path="/batches/new" component={CreateBatch} />
        <Route path="/batches/:id" component={ViewBatch} />
        <Route path="/batches" component={BatchesOverview} />
      </Switch>
    </BatchesContext.Provider>
  );
};

BatchesPage.propTypes = {
  actionsCode: PropTypes.string,
  excludeActions: PropTypes.array,
};

BatchesPage.defaultProps = {
  actionsCode: undefined,
  excludeActions: [],
};

export default BatchesPage;
